import React from 'react';

import PieChart from './PieChart';
import BarChart from './BarChart';

import { ChartType } from 'chart.js';

interface ReportChartProps {
    chartType: ChartType;
    data: {
        labels: string[];
        itemsData: number[];
    };
}

const ReportChart: React.FC<ReportChartProps> = (props) => {
    const { chartType, data } = props;

    if (chartType === 'pie') {
        return <PieChart labels={data.labels} itemsData={data.itemsData} />;
    }

    if (chartType === 'bar') {
        return <BarChart labels={data.labels} itemsData={data.itemsData} />;
    }
    return <div>ReportChart</div>;
};

export default ReportChart;
